/* global settings:true */
/* jshint camelcase: false */

/**
 * Settings Object: This object creates and manipulates the DOM for settings in the View.
 * It is currently in use for admin/setting.
 */

settings = function (id, cui_enabled) {
	'use strict';

	var objSettings = list(null, cui_enabled);
	var domObject = dom(cui_enabled);
	var objDialog = dialog();
	var objValidation = validation();
	var listObject = list(null, cui_enabled);
	var objHermes = hermes();

	/* initialize growls */
	$('#growls').notify();

	objSettings.getFlyout = function(id, callback) {
		$.ajax({
			url: '/admin/setting',
			type: 'GET',
			data: {
				filter: $('#summary-' + id + '-namespace').val(),
				filterType: 'page',
				format: 'true',
				summaryId: id,
				display:'flyout'
			},
			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-summary-column');
				objSettings.destroyEditor();
			},
			success: function(result) {
				var summary = $(result).find('#summary-' + id).addClass('active');
				$('#curriculog-summary-column').html(summary);

				objDom.removeMask('#curriculog-summary-column');

				// bind certain loading events
				switch (id) {
					case '12':
						objSettings.bindEditor();
						//objSettings.preloadImage();
						$('#current-image').imagesLoaded(function() {
							$('#image_loading').hide();
							domObject.removeMask('#image_loading');
							$(this).show();
							objSettings.verticalStretchList();
						});
						break;

					// case '11':
					// 	objHermes.getSystems('#settings-external-systems');
					// 	break;

					default:
						objSettings.verticalStretchList();

				}
				callback && callback();
				Curriculog.Actions.log('settings-flyout-loaded');

			}
		});
	};

	objSettings.hideAccountFlyout = function(){
		$('.open-summary').removeClass('active');
		var detailClosed = $('#curriculog-list-column').outerWidth() - $('#curriculog-summary-column').outerWidth() - 1;
		if ( $('#curriculog-dashboard-column').hasClass('active') === false && $('#curriculog-send-message-column').hasClass('active') === false ){
			$('#curriculog-dashboard-column').addClass('active');
		}
		$('#curriculog-summary-column').animate({'left': detailClosed},
			function() {
				$('.summary.active').removeClass('active');
				$('#curriculog-summary-column').removeClass('active');
			}
		);
	};

	objSettings.sendMessage = function() {
		var message = {
			to : '',
			subject : '',
			message : '',
			copySelf : ''
		};

		// Concat email ids
		$('#users-to li').each(function(){
			message.to += $(this).find('input[name="id"]').val().trim() + ',';
		});

		message.to = message.to.substring(0, message.to.length - 1);
		message.from = $('#curriculog-send-message-column input[name="from-id"]').val();
		message.subject = $('#curriculog-send-message-column input[name="subject"]').val();
		message.message = $('#curriculog-send-message-column textarea[name="message"]').val();
		message.copySelf = $('#curriculog-send-message-column input[name="copySelf"]').is(':checked');

		$.post('/admin/message.json', message, function(result){
			if (result.success > 0) {
				console.log('sent message');
			} else {
				console.log('did not send message');
			}
		});
	};

	// Settings for the account
	objSettings.saveSettings = function(settingId, callback) {

		var settings = {};
		var valid = true;
		var toggleAssessmentModule = false;

		// if IM is disabled, ensure system toggle for SIS ID integration will be disabled
		if ($('#systemHermes').prop('checked') === false ) {
			$('#systemSisIdEnabled').prop('disabled', false);
			$('#systemSisIdEnabled').prop('checked', false);
		}

		//Taking out validatity to consolidate the validation libraries we are using.

		$('#summary-' + settingId + ' select:not(:disabled):not([name="savepoints"]):not(.external-system), #summary-' + settingId + ' input[type="text"]:not(:disabled):not([name="savepoint-create-label"]), #summary-' + settingId + ' input[type="checkbox"]:not(:disabled):not(.external-system), #summary-' + settingId + ' input[type="radio"]:not([name$="Preference"]):not(:disabled):checked, #summary-' + settingId + ' input.hermes-field').each(function(index){
			var value = 0,
			    // cache the jQuery object
			    $this = $(this);

			// check required first since there is no reason to do any other check if there is no value but there is supposed to be
			if ($this.hasClass('required')) {
				// If a fieldset is a child fieldset, make sure it is not disabled before checking the required inputs. Otherwise, always check required
				if (($this.closest('fieldset').hasClass('child-fieldset')
				        && !$this.closest('fieldset').hasClass('disabled'))
				    || !$this.closest('fieldset').hasClass('child-fieldset')) {
					if (!(objSettings.validate($this, 'required'))) {
						valid = false;
					}
				}
			}

			// validate on submit
			if ($this.hasClass('validate-integer')) {
				if (!(objSettings.validate($this, 'integer'))) {
					valid = false;
				}
			} else if ($this.hasClass('validate-url')) {
				if (!(objSettings.validate($this, 'url'))) {
					valid = false;

					if ($this.closest('fieldset').find('span.url-error').length === 0) {
						$('<span class="error url-error">You must enter a valid url, beginning with http://</span>').insertAfter($this);
					}
				}
			} else if ($this.hasClass('validate-email-list')) {
				if (!(objSettings.validate($this, 'email'))) {
					valid = false;
				}
			}

			if ($this.hasClass('number')) {
				if (!($this.val())) {
					valid = true
				} else {
					if (!(objSettings.validate($this, 'integer'))) {
						valid = false;
					}
				}
			}

			if ($this.attr('id') === 'systemClientUrl') {
				if ($this.val().substring(0,7) === 'http://') {
					var url = $this.val().substring(7);
					$this.val(url);
				}
			}

			if($this.attr('id') == 'systemHermesUrl') {
				if ($this.val().substring($this.val().length - 1) == '/') {
					var url = $this.val().substring(0, $this.val().length - 1)
					$this.val(url);
				}
			}


			if ($this.attr('type') === 'checkbox') {
				if (this.name === 'integrationExternalSoftwareNames[]') {
					value = (this.checked ? $this.val().trim() : '');
				} else {
					value = (this.checked ? '1' : '0');
				}
			} else {
				value = $this.val();
				value = $.trim(value);
			}

			if ($this.attr('name') === 'assessmentModule') {
				toggleAssessmentModule = true;
			}

			var setting = {
				name : $this.attr('name'),
				value : value
			};

			var preference = '';
			if ($('input[name="' + $this.attr('name') + 'Preference"]').size() > 0) {
				setting.preference = $('input[name="' + $this.attr('name') + 'Preference"]:checked').val();
			}

			settings[index] = setting;
		});

		if (valid) {
			$.ajax({
				url: '/admin/setting.json',
				type: 'put',
				data: JSON.stringify(settings),
				beforeSend: function() {
					objDom.addMask('#summary-' + settingId + ' .summary-content:eq(0)');
				},
				success: function(result){
					objDom.removeMask('#summary-' + settingId + ' .summary-content:eq(0)');

					if (Number(result.success) === 1) {

						$('#growls').notify('create', 'saved-template', {
							title: 'Settings Saved',
							text: 'The settings have been successfully saved.'
						});

						$('.url-error').remove();


						if(toggleAssessmentModule || result.cuiUpdated) {
							window.location.reload();
						}

						callback && callback(settingId, result);

						Curriculog.Actions.log('settings-saved');

					} else {
						$('#growls').notify('create', 'warning-template', {
							title: 'An Error Occurred',
							text: 'The settings were not saved.'
						});
					}
				}
			});
		}

	};

	/**
	 * Cancel Settings
	 */
	objSettings.cancelSettings = function(settingId, callback) {

		/**
		 * Make ajax call to get settings from DB
		 */
		$.ajax({
			url: '/admin/setting.json',
			type: 'get',
			data: {format : true},
			beforeSend: function() {
				objDom.addCustomMask('#summary-' + settingId + ' .summary-content:eq(0)', 'Cancelling');
			},
			success: function(result){
				objDom.removeMask('#summary-' + settingId + ' .summary-content:eq(0)');

				var serverSettings = {};

				for (var key in result.settings) {
					if (result.settings.hasOwnProperty(key)) {

						var tempName = key.split('_');
						var l=tempName.length;
						var newKey = '';

						for (var i = 0; i< l; i++){

							if (i < 1){
								newKey += tempName[i].toLowerCase();
							} else {
								newKey += tempName[i].charAt(0).toUpperCase() + tempName[i].substr(1).toLowerCase();
							}
						}

						serverSettings[newKey] = result.settings[key];

					}
				}

				callback && callback();

				$('#summary-' + settingId + ' select:not(:disabled), #summary-' + settingId + ' input[type="text"]:not(:disabled), #summary-' + settingId + ' input[type="checkbox"]:not(:disabled), #summary-' + settingId + ' input[type="radio"]:not([name$="Preference"]):not(:disabled):checked, #summary-' + settingId + ' :input[name="systemLdapUrl"],#summary-' + settingId + ' :input[name="systemLdapDn"],#summary-' + settingId + ' :input[name="integrationAcalogKey"],#summary-' + settingId + ' :input[name="integrationAcalogApiUrl"]').each(function(index){
					var value = '';

					if (serverSettings.hasOwnProperty($(this).attr('name'))) {

						key = $(this).attr('name');
						value = serverSettings[key].value;

						/**
						 * Reset the input values
						 */
						if ($(this).attr('type') === 'checkbox' ){
							if (parseInt(value, 10) > 0) {
								$(this).prop('checked', true);
							} else {
								$(this).prop('checked', false);
							}
						} else {
							$(this).val(value);
						}

						/**
						 * Mark the preference for the allowed people to edit
						 */
						var settingPreference = serverSettings[key].preference;
						if (settingPreference.length === 0) {
							settingPreference = 'None';
						}
						var preferenceId = key + 'Preference' + settingPreference.charAt(0).toUpperCase() + settingPreference.substr(1).toLowerCase();
						if ($('#' + preferenceId).size() > 0) {
							$('#' + preferenceId).prop('checked', true);
						}
						var secondary = '';

						/**
						 * Enable / Disable Secondary inputs
						 */
						if ($(this).hasClass('require-secondary')){

							secondary = '';
							switch(this.name) {
							case 'systemLdap':
								secondary = ':input[name="systemLdapUrl"], :input[name="systemLdapDn"]';
								break;
							case 'integrationAcalog':
								secondary = ':input[name="integrationAcalogKey"], :input[name="integrationAcalogApiUrl"]';
								break;

							case 'systemHermes':
								// get all the names of our dynamic selects
								secondary = ':input[name="systemHermesSingular"], :input[name="systemHermesUrl"], :input[name="systemHermesClient"]';

								$('#settings-external-systems select').each(function(index, name) {
									secondary += ', select[name="' + this.name + '"]';
								});
								break;
							}
							objSettings.requireSecondary($(this), secondary);
						}

						if ($(this).hasClass('disable-secondary')){
							secondary = '';
							switch(this.name) {
							case 'integrationExternalSoftware':
								secondary = '#summary-1 :input[name="integrationExternalSoftwareNames[]"]';
								break;
							case 'proposalCollaborationAvailable':
								secondary = ':input[name="proposalCollaborationResults"]';
								break;
							case 'systemLdap':
								secondary = ':input[name="systemLdapUrl"], :input[name="systemLdapDn"]';
								break;
							case 'systemHermes':
								// get all the names of our dynamic selects
								var selects = [];
								$('#settings-external-systems select').each(function(index, name) {
									selects.push('select[name="' + this.name + '"]');
								});
								secondary = ':input[name="systemHermesSingular"], :input[name="systemHermesUrl"], :input[name="systemHermesClient"], select[name="acalog[status]"]';
								break;
							default:
								secondary = '#summary-3 :input[name="' + this.name + 'Days"]';
								break;
							}
							objSettings.disableSecondary($(this), secondary);
						}

					}

				});

				Curriculog.Actions.log('settings-canceled');

			}
		});

	};


	objSettings.activateValidate = function() {
		var hermesEnabled = $('#systemHermes').is(':checked');
		var hasUrl = ($('#systemHermesUrl').val() !== '') ? 1 : 0;
		var hasClient = ($('#systemHermesClient').val() !== '') ? 1 : 0;

		if (hermesEnabled && hasUrl && hasClient) {
			$('button[name="validate-settings"]').removeAttr('disabled');
		} else {
			$('button[name="validate-settings"]').attr('disabled', true);
		}
	};

	objSettings.locationsWarning = function() {
		var dialog = objDialog.createBasicWarningDialog('disable-locations', function(dialog, defaults) {
				var message = "The Locations smartfield will not be included on new Approval Processes after Locations is disabled.";
				$(dialog).append(message);
				defaults.buttons = {
					'Ok': function() {
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);
			}
		);
	};


	/* SAVEPOINTS */
	objSettings.loadSavePoint = function() {
		var data = {
			savepoint : $('select[name="savepoints"]').val().trim()
		};

		var dialog = objDialog.createBasicDialog('load-save-point', 'Load Savepoint', function(dialog, defaults) {
			// Message
			$(dialog).append('<p>Load this Savepoint: ' + data.savepoint + '?</p>');
			$(dialog).append('<p>NOTE: This operation will destroy all current data.</p>');
			$(dialog).append('<p>NOTE: You will be "logged out" upon completion of this operation.</p>');

			// Actions
			defaults.buttons = {
				'Ok': function() {
					$.ajax({
						beforeSend: function() {
							objDom.addCustomMask('#savepoints-column', 'Loading Savepoint... patience');
						},
						url: '/admin/savepoint/load.json',
						type: 'POST',
						data: data,
						complete: function() {
							// console.log("LOAD COMPLETE MAN");
						},
						success: function(data) {
							objDom.removeMask('#savepoints-column');
							objDom.addCustomMask('#savepoints-column', 'You are being logged out now.');
							console.log('growl????');
							$('#growls').notify('create', 'saved-template', {
								title: 'Savepoint Loaded',
								text: 'A savepoint has been successfully loaded.'
							});
							window.location.reload();
						},
						//error: function(results) {
							//window.location.reload();
						//}
					});
					$(this).dialog('close');
				},
				'Cancel': function() {
					$(this).dialog('close');
				}
			};
			defaults.close = function(event, ui) {
				$(this).remove();
			};
			$(dialog).dialog(defaults);
		});
	};


	objSettings.createSavePoint = function() {
		var results = { savepoint : 'unknown', customLabel: '' };
		$('#savepoint-create-label-failed').hide();

		var dialog = objDialog.createDOMDialog('savepoint-create-form', function(dialog, defaults) {
			defaults.width = 400;

			// Actions
			defaults.buttons = {
				'Ok': function() {
					var customLabel = $('#savepoint-create-label').val();
					if ( customLabel !== '' ) {
						if ( ! customLabel.match(/^[a-z0-9\-_]+$/i) ) {
							$('#savepoint-create-label-failed').show();
							$('#savepoint-create-label').attr('value', '');
							return;
						} else {
							customLabel = customLabel.trim();
							results.customLabel = customLabel;
						}
					}
					$.ajax({
						beforeSend: function() {
							objDom.addCustomMask('#savepoints-column', 'Creating Savepoint.... patience');
						},
						url: '/admin/savepoint/create.json',
						type: 'POST',
						data: results,
						complete: function() {
							objDom.removeMask('#savepoints-column');
						},
						cancel: function() {
							$(this).dialog('close');
						},
						success: function(results) {
							objDom.removeMask('#savepoints-column');
							$.ajax({
								beforeSend: function() {
									objDom.addCustomMask('#savepoints-column', 'Reloading list...');
								},
								url: '/admin/savepoint/getfiles.json',
								type: 'POST',
								complete: function() {
									objDom.removeMask('#savepoints-column');
								},
								success: function(results) {
									console.log(results.success);
									var files = results.success;
									$('#savepoints-select').find('option').each(function() {
										$(this).remove();
									});

									$.each(files, function(k, v) {
										$.each(v, function(k, v) {
											$('#savepoints-select').append('<option value="'+ v['file-name'] +'">'+ v['tz-mod-time'] +', Branch: '+ v['git-branch'] +'</option>');
										});
									});
								},
							});
							$('#growls').notify('create', 'saved-template', {
								title: 'Savepoint Creation',
								text: 'A savepoint has been successfully created.'
							});
						},
					});
					$(this).dialog('close');
				},
				'Cancel': function() {
					$(this).dialog('close');
				},
			};
			defaults.close = function(event, ui) {
				$('#savepoint-create-label').attr('value', '');
				$('#savepoint-create-label-failed').hide();
				// hmmm, why does commenting out below, allow the create
				// button to be used again after an operation.  Interesting.
				// well, I ain't arguing with success
				//$(this).remove();
			};
			$(dialog).dialog(defaults);
		});
	};

	/*
	 * Removal of a savepoint
	 */
	objSettings.removeSavePoint = function() {
		var data = {
			savepoint : $('select[name="savepoints"]').val().trim(),
			savepointDesc : '',
		};

		$('select[name="savepoints"]').find('option').each(function() {
			if ( $(this).val() === data.savepoint ) {
				data.savepointDesc = $(this).html();
			}
		});

		var dialog = objDialog.createBasicDialog('remove-save-point', 'Remove Savepoint', function(dialog, defaults) {
			//Message
			$(dialog).append('<p>Remove Savepoint: ' + data.savepointDesc + '?</p>');
			// Actions
			defaults.buttons = {
				'Ok': function() {
					$.ajax({
						beforeSend: function() {
							objDom.addCustomMask('#savepoints-column', 'Removing Savepoint: ' + data.savepoint + '.... patience');
						},
						url: '/admin/savepoint/remove.json',
						type: 'POST',
						data: data,
						complete: function() {
							objDom.removeMask('#savepoints-column');
						},
						cancel: function() {
							$(this).dialog('close');
						},
						success: function(results) {
							objDom.removeMask('#savepoints-column');
							objDom.addCustomMask('#savepoints-column', 'Reloading page...');
							$('#growls').notify('create', 'saved-template', {
								title: 'Savepoint Removed',
								text: 'Savepoint: ' + data.savepoint + ' has been successfully deleted.'
							});
							objDom.removeMask('#savepoints-column');
							objDom.addCustomMask('#savepoints-column', 'updating list...');
							$('#savepoints-select option[value="'+ data.savepoint +'"]').remove();
						},
					});
					$(this).dialog('close');
				},
				'Cancel': function() {
					$(this).dialog('close');
				},
			};
			defaults.close = function(event, ui) {
				$(this).remove();
			};
			$(dialog).dialog(defaults);
		});
	};

/*
 * Reset DB, then entails full destruction of data and remaking of schema
 * based on codebase's current migration levels
 */
	objSettings.resetDb = function() {
		var results = { savepoint : 'unknown' };

		var dialog = objDialog.createBasicDialog('reset-db', 'RESET DB, as in destroy data???', function(dialog, defaults) {
			// Message
			$(dialog).append('<p>RESET DB?</p>');
			$(dialog).append('<p>NOTE: This operation will destroy all current data.</p>');
			$(dialog).append('<p>Note: You will be "logged out" upon completion of this operation.</p>');

			// Actions
			defaults.buttons = {
				'Ok': function() {
					$.ajax({
						beforeSend: function() {
							objDom.addCustomMask('#savepoints-column', 'DB Reset... patience');
						},
						url: '/admin/savepoint/resetdb.json',
						type: 'POST',
						data: results,
						complete: function() {

						},
						success: function(results) {
							objDom.removeMask('#savepoints-column');
							objDom.addCustomMask('#savepoints-column', 'You are being logged out now.');
							$('#growls').notify('create', 'saved-template', {
								title: 'DB Reset',
								text: 'Your DB has been successfully re-set'
							});
							window.location.reload();
						},
						//error: function(results) {
							//window.location.reload();
						//}
					});
					$(this).dialog('close');
				},
				'Cancel': function() {
					$(this).dialog('close');
				}
			};
			defaults.close = function(event, ui) {
				$(this).remove();
			};
			$(dialog).dialog(defaults);
		});
	};

	/* SAVEPOINTS */
	objSettings.addNotifyUsers = function() {
		var dialog = objDialog.createBasicWarningDialog('add-notify-users', function(dialog, defaults) {
			// Message
			$(dialog).append('<p>You are unable to add users to be notified at this time.</p>');
			// Actions
			defaults.buttons = {
				'Ok': function() {
					$(this).dialog('close');
				}
			};

			$(dialog).dialog(defaults);
		});
	};

	objSettings.validate = function(input, type) {
		var elementValue = $(input).val().trim();
		var valid = true;
		var message = '';

		switch (type) {
			case 'required':
				if (objValidation.isEmpty(elementValue)) {
					valid = false;
				}
				break;
			case 'integer':
				if ( !objValidation.isNumeric(elementValue) || objValidation.isZero(elementValue) || objValidation.isEmpty(elementValue) ) {
					valid = false;
				}
				break;
			case 'url':
				if (!objValidation.isUrl(elementValue)) {
					valid = false;
				}
				break;
			case 'email':
				if (!objValidation.isEmail(elementValue)) {
					valid = false;
				}
				break;
			default:
				break;
		}

		if (valid) {
			objValidation.removeError(input, type, function () {}, function () {
				$(input).parents('.summary').find('button[name="save-settings"]').removeAttr('disabled');
			});

			objSettings.verticalStretchList();

			return true;
		} else {
			var details = objValidation.getInputDetails(input);
			var spanId = details[1];

			if ($('#' + spanId).size() < 1 ) {
				var errorMessageHolder = '<span id="' + spanId + '" class="error"></span>';
				var $input = $(input);

				if ($input.next().is('label') && $input.next().attr('for') === $input.attr('id')) {
					$input.next().after(errorMessageHolder);
				} else {
					$input.after(errorMessageHolder);
				}

				$input.addClass('error');

				//Will never be valid so no need to check if it is not valid
				$('#' + spanId).html(objValidation.displayMessage(type));
			}

			objValidation.addError(input, type, valid, false, function(){
				$(input).parents('.summary').find('button[name="save-settings"]').attr('disabled', 'disabled');
			});

			objSettings.verticalStretchList();

			return false;
		}
	};

/*
	disableSecondary ensures that secondary form elements are no longer required to have values when
	the user clicks save.
*/
	objSettings.disableSecondary = function(primary, secondary){
		var optionsEnabled = false;
		if ( !($(primary).is(':checked')) ) {
			optionsEnabled = true;

			// Turn labels, headings and notes off
			$(secondary).closest('.child-fieldset').find('label').addClass('disabled');
			$(secondary).closest('.child-fieldset').find('.note').addClass('disabled');
			$('.secondary-heading').addClass('disabled');
			$(secondary).closest('.child-fieldset').addClass('disabled');

			if ($(secondary).hasClass('error')) {
				objValidation.removeError(secondary, 'integer', function(){}, function(){
					$(secondary).parents('.summary').find('button[name="save-settings"]').removeAttr('disabled');
				});
			}

		} else {
			// Turn labels off
			optionsEnabled = false;
			$(secondary).closest('.child-fieldset').find('label').removeClass('disabled');
			$(secondary).closest('.child-fieldset').find('.note').removeClass('disabled');
			$(secondary).closest('.child-fieldset').removeClass('disabled');
		}

		$(secondary).attr('disabled', optionsEnabled);

	};

/*
	requireSecondary disables and enables the required child elements in a fieldset (toggle the disabled and required class)
*/
	objSettings.requireSecondary = function(primary, secondary){
		var optionsEnabled = false;

		if ( !($(primary).is(':checked')) ) {
			optionsEnabled = true;
			$(secondary).closest('.child-fieldset').addClass('disabled');
			$(secondary).removeClass('required').attr('disabled', 'disabled');
			$('.secondary-heading').addClass('disabled');

			$(secondary).each(function(index, selectedInput){
				// console.log($('label[for="' + selectedInput.name + '"]'));
				$('label[for="' + selectedInput.name + '"]').addClass('disabled');
			});

			if ($(secondary).hasClass('error')) {
				objValidation.removeError(secondary, 'integer', function(){}, function(){
					$(secondary).parents('.summary').find('button[name="save-settings"]').removeAttr('disabled');
				});
			}
		} else {
			$(secondary).closest('.child-fieldset').removeClass('disabled');
			$(secondary).addClass('required').removeAttr('disabled');
			$('.secondary-heading').removeClass('disabled');

			$(secondary).each(function(index, selectedInput){
				$('label[for="' + selectedInput.name + '"]').removeClass('disabled');
			});
		}

		//$(secondary).attr('disabled', optionsEnabled);

	};

/*****
 * Smartfield Settings Functions
 ****/
	objSettings.enableButton = function(input){
		var button = $(input).parents('fieldset:eq(0)').find('input[name="submit"]');
		if (($(input).val()).length > 0){
			$(button).removeAttr('disabled');
		} else {
			$(button).attr('disabled', 'disabled');
		}
	};

	objSettings.refreshSmartfieldList = function(){
		$('div.qtip-active').css('display', 'none').removeClass('qtip-active');
		$.ajax({
			url: '/smartfield.json',
			type: 'GET',
			success: function(result){

				if (result.success > 0){
					$('#summary-9 ul.datasets').empty();
					$(result.datasets).each(function(index, dataset){
						var listItem = '<li id="dataset-' + dataset.id + '" class="status-' + dataset.status;

						listItem += '">' +
						'<span class="dataset-name">' + escapeUserInput(dataset.name) + '</span>' +
						'<div class="dataset-actions">' +
						'<a href="#" class="curriculog-widget edit-widget" title="Edit"></a>' +
						'<a href="#" class="curriculog-widget status-widget" title="';

						if (dataset.status === 'active') {
							listItem += 'De-activate';
						} else {
							listItem += 'Activate';
						}

						listItem += '"></a>' +
						'</div></li>';

						$('#summary-9 ul.datasets').append(listItem);
					});

					$('#curriculog-summary-column').unmask();
				}
			}
		});

	};


	objSettings.saveSmartfieldDataset = function(){
		var datasetName = $('#dataset-details-name').val();

		if (datasetName !== '') {
			$('#curriculog-summary-column').mask('Processing');

			var data = {
				name: $('input[name="dataset-details-name"]').val().trim(),
				id: ($('#dataset-details-id').val() != '') ? $('#dataset-details-id').val() : 0
			};

			$.ajax({
				url: '/smartfield.json',
				type: 'POST',
				data: data,
				success: function(result){

					// result.success is the id of the new dataset
					if (result.success > 0){
						$('#smartfield-dataset-dialog').find('#dataset-details-id').val(result.success);
						$('#smartfield-dataset-dialog').find('#dataset-values-form').find('input, button').removeAttr('disabled');
						objSettings.refreshSmartfieldList();

						$('#growls').notify('create', 'saved-template', {
							title: 'Dataset Added',
							text: 'The dataset has been successfully added.'
						});
					}
				}
			});
		}
	};

	objSettings.verticalStretchList = function() {
		domObject.verticalStretchList();
	};

	objSettings.reloadFlyout = function(id, callback) {
		$.ajax({
			url: '/admin/settings',
			type: 'GET',
			beforeSend: function() {
				domObject.addLoadingMask('#summary-' + id);
			},
			success: function(data){
				domObject.removeMask('#summary-' + id);

				var summary = $(data).find('#summary-' + id);
				$('#summary-' + id).contents().remove();
				$('#summary-' + id).replaceWith(summary);
				$('#summary-' + id).addClass('active');


				$('#image_loading').show();
				domObject.addLoadingMask('#image_loading');
				$('#current-image').hide();

				$('#current-image').imagesLoaded(function() {

					$('#image_loading').hide();
					domObject.removeMask('#image_loading');
					$(this).show();
					objSettings.verticalStretchList();
				});

				if (callback) {
					callback();
				}
			}
		});
	};

	objSettings.preloadImage = function() {
		$('#image_loading').show();
		domObject.addLoadingMask('#image_loading');
		$('#current-image').hide();

		$('#current-image').imagesLoaded(function() {
			$('#image_loading').hide();
			domObject.removeMask('#image_loading');
			$(this).show();
			objSettings.verticalStretchList();
		});
	};

/*****
 * Welcome Page Settings Functions
 ****/

	objSettings.saveWelcomeText = function(text) {
		$.ajax({
			url: '/admin/settings/saveWelcomeText.json',
			type: 'PUT',
			data: {text:text},
			beforeSend: function() {
				domObject.addMask('#summary-12');
			},
			success: function(data){
				domObject.removeMask('#summary-12');
			}
		});
	};

	objSettings.revertWelcomePage = function(callback) {
		$.ajax({
			url: '/admin/settings/revertWelcomePage.json',
			type: 'PUT',
			beforeSend: function() {
				domObject.addMask('#summary-12');
			},
			success: function(data){
				domObject.removeMask('#summary-12');
				if (callback) {
					callback();
				}
			}
		});
	};

	objSettings.bindEditor = function() {
		$('#welcome-page-text').ckeditor({
			bodyClass : 'richtext-field',
			height: 300,
		});

		$('#welcome-page-text').ckeditorGet().on('instanceReady', function(e) {
			objDom.deactivateImageDrop(this, function() {
				objSettings.verticalStretchList();
			});
		});
	};

	objSettings.destroyEditor = function() {
		try {
			$('#welcome-page-text').ckeditorGet().destroy();
		} catch(e) {
			// no editor set up yet.
		}
	};

	return objSettings;
};